import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "../modules/home/Home";
import Login from "../modules/login/login";
import Settings from "../modules/settings/Settings";
import AddUser from "../modules/user/addUser/AddUser";
import BedStatus from "../modules/besStatus/BedStatus";
import UserList from "../modules/user/userList/UserList";
import PatientList from "../modules/patient/PatientList";
import PrivateRoutes from "../HOC/PrivateRoute/PrivateRoutes";
import PageNotFound from "../modules/pageNotFound/PageNotFound";
import ProfileEdit from "../modules/settings/profileEdit/ProfileEdit";
import VerifyEmail from "../modules/login/userVarification/VerifyEmail";
import AddPatient from "../modules/patient/AddPatient";
// import AddPatient from "../modules/patient/AddPatient";
import ForgetPassword from "../modules/login/forgetPassword/ForgetPassword";
import ChangePassword from "../modules/settings/changePassword/ChangePassword";
import VerifyForgetPass from "../modules/login/userVarification/VerifyForgetPass";
import ChangePasswordAfterVerify from "../modules/login/userVarification/ChangePasswordAfterVerify";
import NonLoginRoutes from "../HOC/PrivateRoute/NonLoginRoutes";

import RoutingList from "../../utils/RoutingList";
import { permissions } from "../../constants/permissions";
import Treatment from "../modules/treatment/Treatment";
import Department from "../modules/department/Department";
import AddReferral from "../modules/referral/addReferral/AddReferral";
import AddDepartment from "../modules/department/AddDepartment/AddDepartment";

const Routing = () => {
  return (
    <BrowserRouter>
      <>
        <Routes>
          <Route element={<NonLoginRoutes />}>
            <Route path={RoutingList.login.index} element={<Login />} />
            <Route
              path={RoutingList.login.forgetPassword}
              element={<ForgetPassword />}
            />

            <Route
              path={RoutingList.login.updatePassword}
              element={<VerifyForgetPass />}
            />
            <Route
              path={RoutingList.verify.verifyLink}
              element={<VerifyEmail />}
            />

            <Route
              path={RoutingList.verify.changePasswordAfterVerify}
              element={<ChangePasswordAfterVerify />}
            />
          </Route>

          <Route
            element={
              <PrivateRoutes allowedRoles={permissions?.[RoutingList?.index]} />
            }
          >
            <Route path={RoutingList.index} element={<Home />} />
          </Route>

          <Route
            element={
              <PrivateRoutes
                allowedRoles={
                  permissions?.[RoutingList?.patientAdmission?.index]
                }
              />
            }
          >
            <Route
              path={RoutingList.patientAdmission.index}
              element={<PatientList />}
            />
          </Route>

          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList?.referral?.create]}
              />
            }
          >
            <Route
              path={RoutingList.referral.create}
              element={<AddReferral />}
            />
          </Route>

          <Route
            element={
              <PrivateRoutes
                allowedRoles={
                  permissions?.[RoutingList?.patientAdmission?.create]
                }
              />
            }
          >
            <Route
              path={RoutingList.patientAdmission.create}
              element={<AddPatient key={"addPatient"} />}
            />
          </Route>

          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList.patientAdmission.edit]}
              />
            }
          >
            <Route
              path={`${RoutingList.patientAdmission.edit}/:id`}
              element={<AddPatient key={"editPatient"} />}
            />
          </Route>

          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList?.user?.index]}
              />
            }
          >
            <Route path={RoutingList.user.index} element={<UserList />} />
          </Route>

          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList?.user?.create]}
              />
            }
          >
            <Route path={RoutingList.user.create} element={<AddUser />} />
          </Route>

          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList.user.edit]}
              />
            }
          >
            <Route
              path={`${RoutingList.user.edit}/:id`}
              element={<AddUser />}
            />
          </Route>

          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList.bedStatus.index]}
              />
            }
          >
            <Route path={RoutingList.bedStatus.index} element={<BedStatus />} />
          </Route>
          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList.disease.index]}
              />
            }
          >
            <Route path={RoutingList.disease.index} element={<Treatment />} />
          </Route>
          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList.department.index]}
              />
            }
          >
            <Route
              path={RoutingList.department.index}
              element={<Department />}
            />
          </Route>
          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList.department.create]}
              />
            }
          >
            <Route
              path={`${RoutingList.department.create}`}
              element={<AddDepartment />}
            />
          </Route>
          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList.department.edit]}
              />
            }
          >
            <Route path={`${RoutingList.department.edit}/:id`} element={<AddDepartment />} />
          </Route>
          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList.settings.index]}
              />
            }
          >
            <Route path={RoutingList.settings.index} element={<Settings />} />
          </Route>

          <Route
            element={
              <PrivateRoutes
                allowedRoles={permissions?.[RoutingList.settings.edit]}
              />
            }
          >
            <Route path={RoutingList.settings.edit} element={<ProfileEdit />} />
          </Route>

          <Route
            element={
              <PrivateRoutes
                allowedRoles={
                  permissions?.[RoutingList.settings.change_password]
                }
              />
            }
          >
            <Route
              path={RoutingList.settings.change_password}
              element={<ChangePassword />}
            />
          </Route>

          <Route path={RoutingList.page_not_found} element={<PageNotFound />} />
        </Routes>
      </>
    </BrowserRouter>
  );
};

export default Routing;
